import { Actions } from "../../components/buttons/Actions";
import { GenericSwitch } from "../../components/elements/Switch";
import {
  actionsColumn,
  activeColumn,
  createdColumn,
} from "../../constants/objects";
import { dateTimeFormat } from "../../utils/formatter";
import { randomString, returnObject } from "../../utils/helpers";
import { STATUS_STAFF } from "../../constants/webapp";
import { useAppContext } from "../../context/useAppContext";
import { USERS } from "../../constants/strings";
import { FormLayoutHandler } from "../../pages/layouts/FormLayoutHandler";

export const useUsers = () => {
  const { contextData } = useAppContext();

  const customerTableData = (data, status) => [
    ...data.map((item) => {
      const row = {
        uname: item.uname,
        email: item.email,
        phone: item.phone,
        cart: item.cart,
        orders: item.orders,
        location: item.location,
        active: (
          <GenericSwitch end checked={item.active} docRef={item.docRef} />
        ),
        actions: <Actions actions={[]} />,
        timestamp: dateTimeFormat(item?.timestamp),
        // for staff users
        ...returnObject(status === STATUS_STAFF, {
          timestamp: dateTimeFormat(item?.created),
        }),
        onclick: () =>
          contextData.showGlobalDrawer({
            component: (
              <FormLayoutHandler key={USERS} source={USERS} data={item} />
            ),
            title: "Update User",
          }),
      };
      return row;
    }),
  ];

  const customerTableColumns = [
    { id: "uname", title: "Username", align: "left" },
    { id: "email", title: "Email" },
    // { id: "phone", title: "Phone" },
    // { id: "location", title: "Address" },
    // { id: "orders", title: "Orders" },
    // { id: "cart", title: "Cart" },
    createdColumn,
    activeColumn,
    actionsColumn,
  ];

  return {
    // loading,
    // createUser,
    customerTableColumns,
    customerTableData,
  };
};
